export enum BulkUploadError {
  // New Error codes added for Improved Error Handling in Inbounds flow

  // File-level errors
  FILE_MISSING = "FILE_MISSING",
  FILE_BAD_EXTENSION = "FILE_BAD_EXTENSION",
  FILE_TOO_BIG = "FILE_TOO_BIG",
  FILE_UPLOAD_FAILED = "FILE_UPLOAD_FAILED",

  // Sheet structure errors
  SHEET_TYPE_MISMATCH = "SHEET_TYPE_MISMATCH",
  SHEET_OVERFILLED = "SHEET_OVERFILLED",
  SHEET_NOT_FOUND = "SHEET_NOT_FOUND",
  SHEET_EMPTY = "SHEET_EMPTY",
  SHEET_COLUMN_EXTRANEOUS = "SHEET_COLUMN_EXTRANEOUS",
  SHEET_ROW_EXTRANEOUS = "SHEET_ROW_EXTRANEOUS",
  SHEET_ROW_EXTRANEOUS_REPLENISHMENT = "SHEET_ROW_EXTRANEOUS_REPLENISHMENT",

  // Header validation errors
  HEADER_MISSING = "HEADER_MISSING",
  HEADER_INVALID = "HEADER_INVALID",

  // Data validation errors
  VALUE_BAD_STRING = "VALUE_BAD_STRING",
  VALUE_BAD_WHOLE_NUMBER = "VALUE_BAD_WHOLE_NUMBER",
  VALUE_BAD_NUMBER = "VALUE_BAD_NUMBER",
  VALUE_MISSING = "VALUE_MISSING",

  // MSKU-specific errors
  MSKU_DUPLICATE = "MSKU_DUPLICATE",
  MSKU_TOTAL_EXCESSIVE = "MSKU_TOTAL_EXCESSIVE",
  MSKU_TOO_LONG = "MSKU_TOO_LONG",
  MSKU_DSKU_MISMATCH = "MSKU_DSKU_MISMATCH",
  MSKU_CASE_PACK_MISMATCH = "MSKU_CASE_PACK_MISMATCH",

  // Product validation errors
  PRODUCT_DIMS_OVERSIZED = "PRODUCT_DIMS_OVERSIZED",
  PRODUCT_DOES_NOT_EXIST = "PRODUCT_DOES_NOT_EXIST",
  PRODUCT_ASIN_MISSING = "PRODUCT_ASIN_MISSING",
  PRODUCT_INVENTORY_UNAVAILABLE = "PRODUCT_INVENTORY_UNAVAILABLE",

  // Box/Package validation errors
  BOX_BAD_WEIGHT = "BOX_BAD_WEIGHT",
  BOX_BAD_DIMENSIONS = "BOX_BAD_DIMENSIONS",

  // Seller LPN errors
  SELLER_LPNS_INVALID_COUNT = "SELLER_LPNS_INVALID_COUNT",

  // Date/Lot tracking errors
  EXPIRATION_DATE_INVALID = "EXPIRATION_DATE_INVALID",
  EXPIRATION_DATE_FORMAT_INVALID = "EXPIRATION_DATE_FORMAT_INVALID",

  // Dimension validation errors
  DIMENSION_MISSING = "DIMENSION_MISSING",
  DIMENSION_INVALID = "DIMENSION_INVALID",
  WEIGHT_MISSING = "WEIGHT_MISSING",
  WEIGHT_INVALID = "WEIGHT_INVALID",

  // Units validation errors
  UNITS_INVALID = "UNITS_INVALID",
  UNITS_MISSING = "UNITS_MISSING",
  BOXES_INVALID = "BOXES_INVALID",
  BOXES_MISSING = "BOXES_MISSING",

  // Case pack errors
  DSKU_CASE_PACK_MISMATCH = "DSKU_CASE_PACK_MISMATCH",
  LARGE_CASE_PACK = "LARGE_CASE_PACK",

  // Identifier errors
  MISSING_IDENTIFIER = "MISSING_IDENTIFIER",

  // Inventory errors
  INVENTORY_NOT_AVAILABLE = "INVENTORY_NOT_AVAILABLE",

  // Template errors
  CASE_PACKED_TEMPLATE = "CASE_PACKED_TEMPLATE",
  INDIVIDUAL_TEMPLATE = "INDIVIDUAL_TEMPLATE",

  // Import status errors
  UNABLE_TO_IMPORT_PRODUCTS = "UNABLE_TO_IMPORT_PRODUCTS",
  UNABLE_TO_IMPORT_PRODUCTS_TRY_AGAIN = "UNABLE_TO_IMPORT_PRODUCTS_TRY_AGAIN",
  UNABLE_TO_IMPORT_PRODUCTS_LINK = "UNABLE_TO_IMPORT_PRODUCTS_LINK",

  // System errors
  UNEXPECTED_ERROR = "UNEXPECTED_ERROR",
}
